export interface Identity {
  orgId: string;
  capturedByUserId: string;
}

export interface SessionLike {
  user: { organizationId: string | null; id: string };
}

export interface OfflineProfileLike {
  orgId: string;
  userId: string;
}

/**
 * resolveIdentity (coordinator finding #4) — pure combination logic shared
 * by every place in the app that needs to know "who is currently operating
 * this device" for outbox scoping: `/pending`, the pending-count badges, the
 * duplicate-plate local check, and CheckinPage's own enqueue call. Prefers
 * the live session (the common, online-authenticated case); falls back to
 * the offline profile (offline-shell reopen, task 3.6) — there is no
 * in-memory session at all in that mode. Returns `null` (never a partial
 * identity) when neither source can supply BOTH an org and a user id — a
 * caller must treat `null` as "nothing to scope to yet", not silently query
 * unscoped.
 */
export function resolveIdentity(
  session: SessionLike | null,
  offlineProfile: OfflineProfileLike | null,
): Identity | null {
  const orgId = session?.user.organizationId ?? offlineProfile?.orgId ?? null;
  const capturedByUserId = session?.user.id ?? offlineProfile?.userId ?? null;
  if (!orgId || !capturedByUserId) return null;
  return { orgId, capturedByUserId };
}
